import React from "react";
import { Link, useNavigate } from "react-router-dom";
import logoats from "../../assets/logo/logo.webp";
import { useLanguage } from "../../context/LanguageContext";

interface LogoProps {
    className?: string; 
    imgClassName?: string;
    width?: number | string;
}
// te 
const Logo: React.FC<LogoProps> = ({ className = "", imgClassName = "", width = 60 }) => {
  const navigate = useNavigate();

  const goToHome = (): void => {
    navigate(`${lang}`);
  };

   const lang = useLanguage();

  return (
    <div onClick={goToHome} className={`cursor-pointer ${className}`}>
      <Link to={`${lang}`}>
        <div
          className="mx-auto"
          style={{ width: typeof width === "number" ? `${width}px` : width }}
          >
          <img 
            src={logoats} 
            alt="AMAAR Logo" 
            className={imgClassName}
            loading="eager"
          />
        </div>
        </Link>
    </div>
  );
};

export default Logo;
